import {Component, OnInit} from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { AlertService } from '../shared/services/alert.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AccountService } from '../services/account.service';
import { UserService } from '../services/user.service';
import { UserDto, Role, AddressDto } from '../models/User';
import { NumberValidator } from '../validators/number.validator';
import { CommonService } from '../shared/services/common.service';
import { ApplicantType, RegionType, ZoneType, WoredaType, City, SubCityType } from '../models/CommonModels';
import {ErrorHandlerService} from '../services/error-handler.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as Constants from "../models/Constants";
import { ErisLoginService } from '../services/sso/eris-login.service';
import { ActivatedRoute, Router } from '@angular/router';
import { decodeJwt } from "jose";
import { environment } from '../../environments/environment';
@Component({
  selector: 'app-edit-account',
  templateUrl: './edit-account.component.html',
  styleUrls: ['./edit-account.component.css']
})
export class EditAccountComponent implements OnInit {

  isModal: boolean;
  user: UserDto = new UserDto();
  registerdUser: UserDto;
  editRegistrationForm: FormGroup;
  applicantRoles:  ApplicantType[];
  regionTypes: RegionType[];
  zoneTypes: ZoneType[];
  woredaTypes: WoredaType[];
  subCityTypes: SubCityType[];
  cities: City[];
  userErrorMessage = '';
  showApplicantRole = false;
  roles:Role[] = [];
  showErrors = false;
  showSubCity = false;
  isVerifiedAccount: boolean = false;
  signInUrl: string;
  code: string;
  faydaAccount: any
  returnedFromRedirect: boolean = false;
  theFaydaPsut: string;

  constructor(private formBuilder: FormBuilder, private userService: UserService, private accountService: AccountService,
              private commonService: CommonService, private alertService: AlertService , private errorHandlerService: ErrorHandlerService,
              private modalRef: BsModalRef, private spinner: NgxSpinnerService, private erisLoginService: ErisLoginService,
              private router: Router,
              private route: ActivatedRoute) {
      this.getLocationTypes();
      this.getApplicationTypes();
      this.userService.getRoles().subscribe(
        resp => {
          this.roles = resp;
          let index = this.roles.findIndex(r => r.roleCode === Constants.SUPER_ADMIN);
          this.roles.splice(index, 1);
        },
        error => {
          this.alertService.error('Network error, Please reload the page');
        }
      );
     }

  ngOnInit() {
    this.registerdUser = this.accountService.getUserData();
    this.intializeForm(this.registerdUser);
    console.log("Registered User:", this.registerdUser);
    if (this.registerdUser && this.registerdUser.isFaydaVerified) {
      this.isVerifiedAccount = true;

      this.editRegistrationForm?.controls?.firstName.disable();
      this.editRegistrationForm?.controls?.lastName.disable();
      this.editRegistrationForm?.controls?.email.disable();
      this.editRegistrationForm?.controls?.phone.disable();
    } else {
      this.isVerifiedAccount = false;
    }
    this.signInUrl = this.generateSignInUrl();
    this.code = this.route.snapshot.queryParamMap.get('code');
    console.log("this code baab", this.code)
    if (this.code) {
      this.returnedFromRedirect = true;
      const param = { code: this.code };
      this.fetchToken(param);
    }
  }

  intializeForm(registerdUser: UserDto) {
    this.repopulateZoneAndWoredaList(registerdUser.address?.regionId, registerdUser.address?.zoneId, registerdUser.address?.subCityId);
    this.showErrors = true;
    const secondRoleCodeBatch = [Constants.APPLICANT, Constants.REGISTRANT];
    let roleCodes = []
    this.registerdUser.roles.forEach(r=> {
      let index = this.roles.findIndex(role=> role.id === r.id);
      if( index > -1){
        roleCodes.push(this.roles[index].roleCode);
      }       
    });

    if(intersection(roleCodes, secondRoleCodeBatch).length>0 || registerdUser.userType.name == "Applicant"){
      this.showApplicantRole = true;
    } 
    
    this.editRegistrationForm = this.formBuilder.group({
      firstName: [registerdUser.firstName, [Validators.required]],
      lastName: [registerdUser.lastName, [Validators.required]],
      username: [registerdUser.username, [Validators.required]],
      email: [registerdUser.email , [Validators.required, Validators.email]],
      phone: [registerdUser.phone, [Validators.required, NumberValidator.isPhoneNumber]],
      applicantType: [registerdUser.applicantTypeId, this.showApplicantRole ? [Validators.required] : []],
      address: this.formBuilder.group({
        region: [registerdUser.address ? registerdUser.address.regionId : null, [Validators.required]],
        zone: [registerdUser.address ? registerdUser.address.zoneId : null, [Validators.required]],
        woreda: [registerdUser.address ? registerdUser.address.woredaId : null, [Validators.required]],
        kebele: [registerdUser.address ? registerdUser.address.kebele : null],
        houseNumber: [registerdUser.address ? registerdUser.address.houseNo : null, [Validators.required]],
        city: [registerdUser.address ? registerdUser.address.cityId : null, [Validators.required]],
        subCity: [registerdUser.address ? registerdUser.address.subCityId : null],
      })
    });

    if(this.registerdUser.address?.subCityId){
      this.showSubCity = true;
      this.editRegistrationForm.get('address').get('subCity').setValidators([Validators.required]);
      this.editRegistrationForm.get('address').get('subCity').updateValueAndValidity();
    }

    function intersection(array1, array2){
      return array1.filter(elt=> array2.includes(elt));
    }
  }

  extractPhone(phone: string): string {
    const cleaned = phone.replace(/[^0-9]/g, '');
    const index = cleaned.indexOf('9');
    if (index !== -1) {
      return cleaned.substring(index);
    }
    return cleaned;
  }

  fetchToken(code) {
    const tokenEndpoint = '/oauth/Token';
    this.accountService.getVerifaydaToken(tokenEndpoint, code).subscribe({
      next: (res) => {
        if (res && res.access_token) {
          const userInfoEndpoint = '/oauth/UserInfo';
          const param = { access_token: res.access_token }
          this.accountService.getFaydaUserInfo(userInfoEndpoint, param).subscribe({
            next: async (userInfoResponse) => {
              const decodedUserInfo = decodeJwt(userInfoResponse);
              console.log("Decoded User Info:", decodedUserInfo);
              if (decodedUserInfo) {
                const nameSplitted = (decodedUserInfo?.name as string)?.trim().split(/\s+/);
                decodedUserInfo.firstName = nameSplitted[0];
                decodedUserInfo.lastName = nameSplitted[1];
                decodedUserInfo.phone_number = decodedUserInfo.phone_number ? this.extractPhone(decodedUserInfo.phone_number as string) : null;
                this.faydaAccount = decodedUserInfo;
                this.updateFormWithFaydaData(decodedUserInfo);
              }
            },
            error: (err) => {
              console.error("Error fetching user info:", err);
            }
          });
        }
      },
      error: (err) => {
        console.error("Error fetching token:", err);
      }
    });

  }

  get control() { return this.editRegistrationForm.controls; }

  updateFormWithFaydaData(faydaUserData) {
    this.editRegistrationForm?.controls?.firstName?.setValue(
      faydaUserData.firstName
    );
    this.editRegistrationForm?.controls?.firstName?.disable();

    this.editRegistrationForm?.controls?.lastName?.setValue(
      faydaUserData.lastName
    );
    this.editRegistrationForm?.controls?.lastName?.disable();

    faydaUserData.email ? this.editRegistrationForm?.controls?.email?.setValue(
      faydaUserData.email
    ) : null;
    faydaUserData.email ? this.editRegistrationForm?.controls?.email?.disable() : null;

    faydaUserData.phone_number ? this.editRegistrationForm?.controls?.phone?.setValue(
      faydaUserData.phone_number
    ) : null;
    faydaUserData.phone_number ? this.editRegistrationForm?.controls?.phone?.disable() : null;
    this.theFaydaPsut = faydaUserData.sub || '';
  }

  getApplicationTypes(): void {
    this.commonService.getApplicationTypes().subscribe(applicationTypes => {
      this.applicantRoles = applicationTypes;
    });
  }

  getLocationTypes() {
    this.commonService.getRegionTypes().subscribe(regionTypes => {
      this.regionTypes = regionTypes;
    });
    this.commonService.getCities().subscribe(cities => {
      this.cities = cities;
    });
  }

  sortHierarchy = function (adminBoundary, source: string) {
    let selectedBoundaryID = adminBoundary !== null ? adminBoundary.id : -1;
    switch (source) {
      case 'region':
        this.commonService.getZoneTypesByRegion(selectedBoundaryID).subscribe(zoneTypes => {
          this.zoneTypes = zoneTypes;
        });
        break;
      case 'zone':
        if(adminBoundary.isCity){
          this.commonService.getSubCityTypesByZone(selectedBoundaryID).subscribe(subCityTypes => {
            this.subCityTypes = subCityTypes;
          });
        } else {
          this.commonService.getWoredaTypesByZone(selectedBoundaryID).subscribe(woredaTypes => {
            this.woredaTypes = woredaTypes;
          });
        }
        break;
      case 'subCity':
        this.commonService.getWoredaTypesBySubCity(selectedBoundaryID).subscribe(woredaTypes => {
          this.woredaTypes = woredaTypes;
        });
        break;
      default:
        break;
    }
  };

  hideModal() {
    this.modalRef.hide();
  }

  updateHierarchyLists(adminBoundary: any, source: string) {
    if (adminBoundary !== undefined) {
      switch (source) {

        case 'region':
          adminBoundary = <RegionType>adminBoundary;
          this.editRegistrationForm.controls.address['controls'].zone.setValue(null);
          this.editRegistrationForm.controls.address['controls'].woreda.setValue(null);
          this.sortHierarchy(adminBoundary, source);
          this.woredaTypes = [];
          break;
        case 'zone':
          adminBoundary = <ZoneType>adminBoundary;
          this.showSubCity = adminBoundary.isCity ? true: false;
          if(adminBoundary.isCity){
            this.editRegistrationForm.get('address').get('subCity').setValidators([Validators.required]);  
          } else {
            this.editRegistrationForm.get('address').get('subCity').clearValidators();
          }
          this.editRegistrationForm['controls'].address['controls'].woreda.setValue(null);
          this.editRegistrationForm['controls'].address['controls'].subCity.setValue(null);
          this.editRegistrationForm.get('address').get('subCity').updateValueAndValidity();
          this.sortHierarchy(adminBoundary, source);
          break;
        case 'subCity':
          adminBoundary = <ZoneType>adminBoundary;
          this.editRegistrationForm['controls'].address['controls'].woreda.setValue(null);
          this.sortHierarchy(adminBoundary, source);
          break;
      }
    }
  }

  private normalize(val: string): string {
    return (val || '').trim().toLowerCase();
  }

  private normalizePhone(val: string): string {
    return this.extractPhone(val || '');
  }

  editAccount() {
    this.spinner.show();
    console.log(this.control);
    this.user.id = this.registerdUser.id;
    this.user.firstName = this.control.firstName.value;
    this.user.lastName = this.control.lastName.value;
    this.user.email = this.control.email.value;
    this.user.applicantTypeId = this.control.applicantType.value;
    this.user.username = this.control.username.value;
    this.user.phone = this.control.phone.value;
    this.user.userType = this.registerdUser.userType;
    this.user.address = new AddressDto();
    this.user.address.setFormData(this.control.address);
    this.user.roles = this.registerdUser.roles;
    this.user.departments = this.registerdUser.departments;
    this.user.branchOfficeId = this.registerdUser.branchOfficeId;
    // all made or condition because name can not be edited after fayda redirect.
    if (!this.isVerifiedAccount && this.faydaAccount && (
      this.normalize(this.user.firstName) === this.normalize(this.faydaAccount.firstName) ||
      this.normalize(this.user.lastName) === this.normalize(this.faydaAccount.lastName) ||
      this.normalizePhone(this.user.phone) === this.normalizePhone(this.faydaAccount.phone_number) ||
      this.normalize(this.user.email) === this.normalize(this.faydaAccount.email))
    ) {
      this.user.isFaydaVerified = true;
      this.user.faydaPsut = this.theFaydaPsut;
    } else if (this.isVerifiedAccount) {
      this.user.isFaydaVerified = true;
      this.user.faydaPsut = this.registerdUser.faydaPsut;
    } else {
      this.user.isFaydaVerified = false;
      this.user.faydaPsut = "";
    }
    console.log("this is the user service parameter", this.user)
    this.userService.updateUser(this.user).subscribe(
      resp => {
          this.alertService.success('Account has been successfully updated.');

          this.userService.getUser(this.erisLoginService.getUserId()).subscribe(user => {
            this.accountService.storeUserData(user);

            if(this.accountService.getMenu().length == 0){ 
              this.userService.getUserMenus().subscribe(menu => {
                this.accountService.storeMenuConfig(menu);
                if(!this.isModal){
                  this.router.navigateByUrl('/welcome');
                } else {
                  window.location.reload();
                }
              });
            } else {
              if(!this.isModal) this.router.navigateByUrl('/welcome');            
            }

          });
		  this.spinner.hide();
          this.modalRef.hide();      
      },
      error => {
        this.spinner.hide();
        let errorMsg = this.errorHandlerService.handleApiError(error);
        this.userErrorMessage = errorMsg + ' , please try again';
        this.alertService.error('Updating account failed, please try again later');
        this.modalRef.hide();
      }
    );

  }

  repopulateZoneAndWoredaList(regionID: number, zoneID: number, subCityID: number) {

    this.commonService.getZoneTypesByRegion(regionID).subscribe(zoneTypes => {
      this.zoneTypes = zoneTypes;
    });

    if(subCityID){
      this.commonService.getSubCityTypesByZone(zoneID).subscribe(subCityTypes => {
        this.subCityTypes = subCityTypes;
      });
      this.commonService.getWoredaTypesBySubCity(subCityID).subscribe(woredaTypes => {
        this.woredaTypes = woredaTypes;
      });
      this.showSubCity = true;
    } else {
      this.commonService.getWoredaTypesByZone(zoneID).subscribe(woredaTypes => {
        this.woredaTypes = woredaTypes;
      });
    }
  }

  generateSignInUrl(): string {
    const params = new URLSearchParams({
      client_id: `${environment.nidClientId}`,
      redirect_uri: `${environment.clientRoot}account/edit`,
      response_type: 'code',
      scope: 'openid profile email',
      acr_values:
        'mosip:idp:acr:generated-code mosip:idp:acr:linked-wallet mosip:idp:acr:biometrics',
      claims: JSON.stringify({
        userinfo: {
          name: { essential: true },
          phone: { essential: true },
          email: { essential: true },
          picture: { essential: true },
          gender: { essential: true },
          birthdate: { essential: true },
          address: { essential: true },
        },
        id_token: {},
      }),
      code_challenge: 'E9Melhoa2OwvFrEMTJguCHaoeK1t8URWbuGJSstw-cM',
      code_challenge_method: 'S256',
      display: 'page',
      nonce: 'g4DEuje5Fx57Vb64dO4oqLHXGT8L8G7g',
      state: 'ptOO76SD',
      ui_locales: 'en',
    });

    const authEndpoint = `${environment.nidAuthEndpoint}`; // Replace with env variable
    return `${authEndpoint}?${params.toString()}`;
  }

  generateUUID(): string {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

}
